export { default } from "./AmtAttach";
